import React from "react";
import Products from "../Components/Products";

const ProductsPage = () => {
    return (
        <div>
            <Products />
        </div>
    )
}

export default ProductsPage;
